import {Component, inject} from '@angular/core';
import {LoadingService} from "../../../core/services/loading.service";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-spinner',
    imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
    private loadingService = inject(LoadingService);
    public isLoading$ = this.loadingService.loading$;
}
